module.exports = __webpack_public_path__ + "static/media/periscope.b27e79b7.png";